/**
 * useHotspotSearch — BLOCKER #30
 *
 * Sucht via GET /api/v2/hotspots/search?q=<query> — im Unterschied zu
 * useGlobalSearch (user-scoped, /api/v2/search) durchsucht dieser Endpunkt
 * ALLE Hotspots des Netzwerks, unabhaengig vom Besitz. Fuer AddHotspotModal:
 * ein Hotspot, den man erst claimen will, gehoert dem User noch nicht.
 *
 * Backend-Contract: q < 3 Zeichen liefert eine leere Liste mit Status 200;
 * Limit 10, sortiert nach Name.
 */
import { useQuery } from '@tanstack/react-query'
import apiClient from '../../lib/api-client'

export type HotspotSearchHit = {
  id: number
  name: string | null
  address: string
}

const MIN_QUERY_LENGTH = 3

export function useHotspotSearch(query: string) {
  return useQuery<HotspotSearchHit[]>({
    queryKey: ['hotspot-search', query],
    queryFn: async ({ signal }) => {
      const result = await apiClient.GET('/api/v2/hotspots/search', {
        params: { query: { q: query } },
        signal,
      })
      if (result.error) throw result.error
      // Contract markiert alle Felder optional (keine `required`-Liste im Schema);
      // Treffer ohne id sind fuer die UI nicht adressierbar (key/claim) und werden verworfen.
      return (result.data?.data ?? []).flatMap((h) =>
        h.id === undefined ? [] : [{ id: h.id, name: h.name ?? null, address: h.address ?? '' }],
      )
    },
    enabled: query.trim().length >= MIN_QUERY_LENGTH,
    staleTime: 30_000,
    gcTime: 60_000,
    retry: false,
  })
}
